import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_020.jpg';
page.images = [
  {
    imageId: 'page020_zoom0',
    rectangle: {
      x: 975,
      y: 1987,
      width: 795,
      height: 478,
    },
    imageSrc: 'images/page020/020 4.jpg',
  },
  {
    imageId: 'page020_zoom1',
    rectangle: {
      x: 140 + 155,
      y: 1985,
      width: 800 - 155,
      height: 478,
    },
    imageSrc: 'images/page020/020 3.jpg',
  },
  {
    imageId: 'page020_zoom2',
    rectangle: {
      x: 140,
      y: 323,
      width: 1635,
      height: 1400,
    },
    imageSrc: 'images/page020/020 11.jpg',
  },
  // {
  //   imageId: 'page020_zoom3',
  //   rectangle: {
  //     x: 138,
  //     y: 323,
  //     width: 1635,
  //     height: 755,
  //   },
  //   imageSrc: 'images/page020/020 1.jpg',
  // },
];
page.paint = [
  {
    id: 'page010_game2',
    icon: 'ikona_cw2',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Znajdź szczegóły, którymi różnią się obrazki. Kliknij <br/>w ikonę programu Paint.',
      audio: 'files/page010/z10c2.mp3',
      item: {
        path: 'informatyka/files/page010/z.10cw.2.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 200,
    },
  },
  {
    id: 'page010_game3',
    icon: 'ikona_cw3',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Powiększ fragmenty rysunku za pomocą narzędzia <i>Lupa</i>.  ',
      audio: 'files/page010/z10c3.mp3',
      item: {
        path: 'informatyka/files/page010/z.10cw.3.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 400,
    },
  },
];
page.games = [
  {
    id: 'page010_game1',
    tooltip: '',
    icon: 'ikona_cw1',
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  // {
  //   id: 'page010_game2',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: RIGHT,
  //     y: 200,
  //   },
  // },
  // {
  //   id: 'page010_game3',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: RIGHT,
  //     y: 400,
  //   },
  // },
  {
    id: 'page010_game4',
    tooltip: '',
    icon: 'ikona_cw4',
    pos: {
      x: LEFT,
      y: 600,
    },
  },
  // {
  //   id: 'page010_game5',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: RIGHT,
  //     y: 800,
  //   },
  // },
];
export default page;
